import React, { useState, useEffect } from 'react';
import { UpOutlined } from '@ant-design/icons';
import './BackToTop.css';

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);
  const [carouselHeight, setCarouselHeight] = useState(760);
  const [isAtBottom, setIsAtBottom] = useState(false);

  useEffect(() => {
    // 动态获取轮播图高度
    const getCarouselHeight = () => {
      const carouselElement = document.querySelector('.carousel-container');
      if (carouselElement) {
        setCarouselHeight(carouselElement.offsetHeight);
      }
    };

    // 初始获取高度
    getCarouselHeight();

    // 监听窗口大小变化，重新获取轮播图高度
    const handleResize = () => {
      getCarouselHeight();
    };

    window.addEventListener('resize', handleResize);

    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const documentHeight = document.documentElement.scrollHeight - window.innerHeight;

      // 当滚动超过轮播图高度时显示按钮
      setIsVisible(scrollTop > carouselHeight);

      // 计算滚动进度（0-1之间的值）
      // 使用更平滑的进度计算，让水波效果更自然
      const progress = Math.min(scrollTop / (documentHeight * 0.8), 1);
      setScrollProgress(progress);

      // 检测是否接近底部（距离底部50px以内）
      const threshold = 50;
      const isNearBottom = scrollTop + window.innerHeight >= document.documentElement.scrollHeight - threshold;
      setIsAtBottom(isNearBottom);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, [carouselHeight]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // 计算水波的扩散程度 - 真正的水波效果
  const waveScale1 = 0.2 + scrollProgress * 0.8; // 从20%到100%
  const waveScale2 = Math.max(0, (scrollProgress - 0.2) * 1.25); // 延迟启动的第二层
  const waveScale3 = Math.max(0, (scrollProgress - 0.4) * 1.67); // 延迟启动的第三层
  const waveScale4 = Math.max(0, (scrollProgress - 0.6) * 2.5); // 最外层，最后出现

  return (
    <div
      className={`back-to-top ${isVisible ? 'visible' : ''} ${isAtBottom ? 'at-bottom' : ''}`}
      onClick={scrollToTop}
    >
      {/* 最外层水波 - 最大最淡 */}
      <div
        className="wave-circle wave-4"
        style={{
          transform: `translate(-50%, -50%) scale(${waveScale4})`,
          opacity: waveScale4 * 0.15
        }}
      ></div>

      {/* 第三层水波 */}
      <div
        className="wave-circle wave-3"
        style={{
          transform: `translate(-50%, -50%) scale(${waveScale3})`,
          opacity: waveScale3 * 0.25
        }}
      ></div>

      {/* 第二层水波 */}
      <div
        className="wave-circle wave-2"
        style={{
          transform: `translate(-50%, -50%) scale(${waveScale2})`,
          opacity: waveScale2 * 0.35
        }}
      ></div>

      {/* 第一层水波 - 最小最浓 */}
      <div
        className="wave-circle wave-1"
        style={{
          transform: `translate(-50%, -50%) scale(${waveScale1})`,
          opacity: waveScale1 * 0.5
        }}
      ></div>

      {/* 进度环 */}
      <svg className="progress-ring" width="60" height="60">
        <circle
          className="progress-ring-circle"
          stroke="#1C5A4A"
          strokeWidth="2"
          fill="transparent"
          r="28"
          cx="30"
          cy="30"
          style={{
            strokeDasharray: `${2 * Math.PI * 28}`,
            strokeDashoffset: `${2 * Math.PI * 28 * (1 - scrollProgress)}`,
            transform: 'rotate(-90deg)',
            transformOrigin: '50% 50%'
          }}
        />
      </svg>

      {/* 主按钮 */}
      <div className="back-to-top-button">
        <UpOutlined />
      </div>
    </div>
  );
};

export default BackToTop;
